import $ from 'jquery';
export class RichText {
    constructor() {
        this.selector = '.richtext';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            const $paragraphs = $(element).find('p');
            if ($paragraphs.length === 0)
                return;
            $paragraphs.each((_, element) => {
                $(element).text().replace(/\s|&nbsp;/g, '');
            });
        });
    }
}
